import * as React from 'react';
import { ReactElement, useState } from 'react';
import { AchievementBadgeWrapper } from './AchievementBadge.styled';
import FormCheckbox from 'components/common/searchfilter/FormCheckbox';
import { CircularProgress } from '@material-ui/core';
import { SpinnerSpacing } from '../common/spinner/Spinner.styled';
import { ConnectAchievementBadge } from 'types/member';
import { useDispatch, useSelector } from 'react-redux';
import {
  memberDetailActions,
  selectAchievementBadgeLoading,
} from 'features/member/reducer/memberDetailSlice';

interface Props {
  userId: string;
  specialBadges: {
    badgeType: ConnectAchievementBadge;
    achieve: boolean;
  }[];
}

const isChecked = (
  specialBadges: {
    badgeType: ConnectAchievementBadge;
    achieve: boolean;
  }[],
  badgeType: ConnectAchievementBadge,
): boolean => {
  return specialBadges.find(badge => badge.badgeType === badgeType)?.achieve ?? false;
};

const AchievementBadge = ({ userId, specialBadges }: Props): ReactElement => {
  const dispatch = useDispatch();
  const updating = useSelector(selectAchievementBadgeLoading);

  const [achievementBadges, setAchievementBadges] = useState<
    {
      badgeType: ConnectAchievementBadge;
      achieve: boolean;
    }[]
  >(specialBadges);

  const updateAchievementBadgeCheckbox = (
    badgeType: ConnectAchievementBadge,
    achieve: boolean,
  ): void => {
    setAchievementBadges(prev =>
      prev.map(badge => (badge.badgeType === badgeType ? { ...badge, achieve } : badge)),
    );
  };

  const handleAchievementBadgeChange = (badgeType: ConnectAchievementBadge): void => {
    const checked = !isChecked(achievementBadges, badgeType);

    updateAchievementBadgeCheckbox(badgeType, checked);
    dispatch(
      memberDetailActions.updateConnectBadge({
        userId,
        badgeType,
        achieve: checked,
      }),
    );
  };

  return (
    <AchievementBadgeWrapper>
      <FormCheckbox
        label="Community Hero"
        checked={isChecked(achievementBadges, ConnectAchievementBadge.COMMUNITY_HERO)}
        onChange={() => handleAchievementBadgeChange(ConnectAchievementBadge.COMMUNITY_HERO)}
      />
      <FormCheckbox
        label="CONNECT Supporters"
        checked={isChecked(achievementBadges, ConnectAchievementBadge.CONNECT_SUPPORTERS)}
        onChange={() => handleAchievementBadgeChange(ConnectAchievementBadge.CONNECT_SUPPORTERS)}
      />
      {updating && (
        <SpinnerSpacing>
          <CircularProgress size={19} thickness={4} />
        </SpinnerSpacing>
      )}
    </AchievementBadgeWrapper>
  );
};

export default AchievementBadge;
